//@ts-nocheck
// src/components/dashboard/Sidebar.tsx
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Transition } from "@headlessui/react";
import { Dialog } from "@headlessui/react";
import CustomMenuDropdown from "../common/CustomMenuDropdown";
import { UserDetails } from "../../features/auth/authTypes";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { logoutUser } from "../../features/auth/authSlice";
import { Toaster, toast } from "sonner";
import { RootState } from "../../app/store";
import {
  BaseSettingIcon,
  CalenderIcon,
  CustomUserIcon,
  DocumentIcon,
  FlagIcon,
  FolderIcon,
  HomeIcon,
  LogoutIcon,
  ProfileSettingIcon,
  SettingIcon,
  SwitchBaseIcon,
  TeamIcon,
  UserRoleIcon,
  baseNameIcon,
} from "../icons";
import {
  ActivityIcon,
  ChartPieIcon,
  InboxIcon,
  KanbanIcon1,
  ManageJobIcon,
  MyJobIcon,
  PipelineIcon,
  ReportIcon,
  SquareCheckIcon,
  UsersIcon,
} from "../icons/Icons";
import { fetchDocument, fetchJobList } from "../../features/job/jobSlices";
import { useSearch } from "../../context/SearchContext";
import { useSidebar } from "../../context/SidebarContext";
import CustomMenuDropdownVertical from "../common/CustomMenuDropdownVertical";
import VerticalSidebar from "../dashboard/VerticalSidebar";
import CommandKSearchDialog from "../dashboard/CommandKSearchDialog";
import { useJob } from "../dashboard/JobContext";
import CommandKSearchJob from "./CommandKSearchJob";
import JobVerticleSidebar from "./JobVerticleSidebar";
import { X } from "lucide-react";
import { _baseRequest, COMMON } from "../../utils/baseApi";
import { tr } from "date-fns/locale";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

interface SidebarProps {
  userDetails: UserDetails;
}

const Sidebar: React.FC<SidebarProps> = ({ userDetails, baseSwitchData }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const [updatedPathname, setUpdatedPathname] = useState<string>("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [updateChannelName, setUpdateChannelName] = useState("");
  const [updateBaseLogo, setUpdateBaseLogo] = useState(null);
  const [updateProfileImage, setUpdateProfileImage] = useState("");
  const baseDetailsData = useAppSelector(
    (state: RootState) => state.base.baseDetails,
  );
  const userBaseIdMain = userDetails?.id || userDetails;
  const [userData, setUserData] = useState<any>(null);
  const [userBaseData, setUserBaseData] = useState<any>(null);
  const [userId, setUserId] = useState<any>(null);
  const userDetailsFromRedux = useAppSelector(
    (state: any) => state?.base?.baseDetails,
  );
  const [jobsList, setJobsList] = useState<any>([]);
  const [userDetails1, setUserDetails1] = useState<any>(null);
  const bases = useAppSelector(
    (state: RootState) => state?.base?.data?.data?.bases,
  );
  const { setSearchTerm, searchTerm } = useSearch();
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  const [isHovered, setIsHovered] = useState(false);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const [showSetting, setShowSetting] = useState(false);
  const [applicationDetails, setapplicationDetails] = useState("");
  const userNameRef = useRef(null);
  const [baseName, setBaseName] = useState<any>(null);
  //   const { jobStatus } = useJob();
  const [saveSwitchBaseData, setSaveSwitchBaseData] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("problem");
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileErrors, setFileErrors] = useState<string[]>([]);
  const [message, setMessage] = useState("");

  const renderTabContent = () => {
    switch (selectedTab) {
      case "problem":
        return (
          <div className="flex flex-col gap-y-3">
            <h2 className="text-[15px] text-[#303031] font-medium leading-[1.4375rem]">
              Contact Us
            </h2>
            <p className="text-[13px] text-[#5e5e5f] font-normal leading-normal">
              How can we make teamer better? If you have a feature request,
              question or any problem, feel free to ask.
            </p>
            <span className="border-b border-solid border-[#e3e3e3] mx-[-32px]"></span>
          </div>
        );
      case "question":
        return (
          <div className="flex flex-col gap-y-3">
            <h2 className="text-[15px] text-[#303031] font-medium leading-[1.4375rem]">
              Contact Us
            </h2>
            <p className="text-[13px] text-[#5e5e5f] font-normal leading-normal">
              How can we make teamer better? If you have a feature request,
              question or any problem, feel free to ask.
            </p>
            <span className="border-b border-solid border-[#e3e3e3] mx-[-32px]"></span>
          </div>
        );
      case "feedback":
        return (
          <div className="flex flex-col gap-y-3">
            <h2 className="text-[15px] text-[#303031] font-medium leading-[1.4375rem]">
              Contact Us
            </h2>
            <p className="text-[13px] text-[#5e5e5f] font-normal leading-normal">
              How can we make teamer better? If you have a feature request,
              question or any problem, feel free to ask.
            </p>
            <span className="border-b border-solid border-[#e3e3e3] mx-[-32px]"></span>
          </div>
        );
      default:
        return null;
    }
  };

  const getPlaceholderText = () => {
    switch (selectedTab) {
      case "problem":
        return "Something seems wrong...";
      case "question":
        return "How do I...";
      case "feedback":
        return "What if...";
      default:
        return "Please enter your message...";
    }
  };

  useEffect(() => {
    if (bases && bases.length > 0) {
      const matchedBase = bases.find(
        (base: { id: number }) => base.id.toString() === baseId,
      );
      if (matchedBase) {
        setUserDetails1(matchedBase);
      }
    } else if (baseId) {
      setUserDetails1(baseId);
    } else {
      setUserDetails1(null);
    }
  }, [baseId, bases]);

  const navigation = [
    {
      name: "My jobs",
      to: `/${baseId}/dashboard`,
      icon: MyJobIcon,
      current: location.pathname === `/${baseId}/dashboard`,
    },
    {
      name: "Manage jobs",
      to: `/${baseId}/jobs`,
      icon: ManageJobIcon,
      current: location.pathname === `/${baseId}/jobs`,
    },
  ];

  const handleSignOut = () => {
    const clearAllStorageData = () => {
      // Clear all localStorage
      localStorage.clear();

      // Specifically remove items related to authentication and persistence
      const keysToRemove = [
        "accessToken",
        "authToken",
        "persist:root",
        "_persist",
      ];

      keysToRemove.forEach((key) => localStorage.removeItem(key));

      // If you're using cookies for any auth data, clear them here
      // For example:
      // document.cookie.split(";").forEach(c => {
      //   document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      // });
    };

    dispatch(logoutUser())
      .then((resultAction) => {
        if (logoutUser.fulfilled.match(resultAction)) {
          clearAllStorageData();
          toast.success("Successfully logged out!");

          // Use a slight delay to ensure storage clearing is complete
          setTimeout(() => {
            navigate("/login");
          }, 100);
        } else if (logoutUser.rejected.match(resultAction)) {
          const payload = resultAction.payload as {
            status?: number;
            message: string;
          };
          if (payload.status === 401) {
            clearAllStorageData();
            toast.error("Session expired. Please log in again.");

            setTimeout(() => {
              window.location.href = "/login";
            }, 100);
          } else {
            toast.error("Logout failed. Please try again.");
          }
        }
      })
      .catch((error) => {
        console.error("Logout action failed", error);
        toast.error("Logout action failed. Please try again.");
      });
  };

  // base details

  useEffect(() => {
    const userBaseDetailsString = localStorage.getItem("baseDetails");
    if (userBaseDetailsString) {
      try {
        const userBaseDetails = JSON.parse(userBaseDetailsString); // Declare the variable here
        setUserBaseData(userBaseDetails?.data);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  // user details
  useEffect(() => {
    const userDetailsString = localStorage.getItem("userDetails");
    if (userDetailsString) {
      try {
        const userDetails = JSON.parse(userDetailsString);
        setUserData(userDetails);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails);
  }, []);

  const handleBaseNavigate = () => {
    navigate("/base");
  };

  const handleProfileSetting = () => {
    navigate(`/user/${userId?.id}/profile`);
  };

  const handleBaseSetting = () => {
    navigate(`/${baseId}/settings/base`);
  };

  // user details
  // useEffect(() => {
  //   const userDetailsString = localStorage.getItem('baseSwitchDetails');
  //   if (userDetailsString) {
  //     try {
  //       userDetails = JSON.parse(userDetailsString);
  //       setSaveSwitchBaseData(userDetails)
  //     } catch (e) {
  //       console.error("Error parsing userDetails:", e);
  //     }
  //   }
  // }, [baseSwitchData]);

  // custom dropdown
  const profileMenuSections = [
    {
      options: [
        {
          icon: CustomUserIcon,
          label: userData?.name,
          onClick: () => console.log("Profile clicked"),
        },
        {
          icon: ProfileSettingIcon,
          label: "Profile Setting",
          onClick: handleProfileSetting,
        },
      ],
    },
    {
      options: [
        {
          icon: baseNameIcon,
          label: userBaseData?.base?.name || userDetailsFromRedux?.name,
          onClick: () => console.log("Profile clicked"),
        },
        {
          icon: UserRoleIcon,
          label: baseSwitchData?.role,
          onClick: () => console.log("Profile clicked"),
        },
        // { icon: CogIcon, label: 'Base Setting', onClick: handleBaseSetting },
        ...(baseSwitchData?.role === "admin"
          ? [
              {
                icon: BaseSettingIcon,
                label: "Base Setting",
                onClick: handleBaseSetting,
              },
            ]
          : []),
      ],
    },
    //     {
    //   options: [
    //     { icon: baseNameIcon, label: userBaseData?.base?.name || userDetailsFromRedux?.name, onClick: () => console.log('Profile clicked') },
    //     { icon: UserRoleIcon, label: userData?.role || userBaseData?.base?.role, onClick: () => console.log('Profile clicked') },
    //     // { icon: CogIcon, label: 'Base Setting', onClick: handleBaseSetting },
    //     ...(userData?.role === 'admin'
    //       ? [{ icon: BaseSettingIcon, label: 'Base Setting', onClick: handleBaseSetting }]
    //       : []),
    //   ],
    // },
    {
      options: [
        {
          icon: SwitchBaseIcon,
          label: "Create/Switch Base",
          onClick: handleBaseNavigate,
        },
      ],
    },
    {
      options: [
        { icon: LogoutIcon, label: "Sign out", onClick: handleSignOut },
      ],
    },
  ];

  // fetch base name
  useEffect(() => {
    // Retrieve and parse the stored channel data
    const storedData = localStorage.getItem("baseDetails");
    //  const baseData = baseDetailsData
    const finalData = storedData || baseDetailsData;

    if (finalData) {
      try {
        // const parsedData = JSON.parse(finalData);
        const parsedData =
          typeof finalData === "string" ? JSON.parse(finalData) : finalData;

        if (parsedData?.data?.base?.name) {
          setUpdateChannelName(parsedData?.data?.base?.name);
        } else if (finalData?.name) {
          setUpdateChannelName(parsedData?.name);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, []);

  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("baseDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);

        if (parsedData && parsedData.data.base && parsedData.data.base.logo) {
          setUpdateBaseLogo(
            parsedData && parsedData.data.base && parsedData.data.base.logo,
          );
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);

  // fetch user image
  const imageUrl = updateProfileImage
    ? `${process.env.REACT_APP_API_BASE_URL}/${updateProfileImage}`
    : "";
  // https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80
  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("userDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData && parsedData.profile_pic) {
          setUpdateProfileImage(parsedData && parsedData.profile_pic);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);

  const handleTeamMemberDataSave = () => {};

  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      setSearchTerm(searchValue);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  // Fixed hook usage
  useEffect(() => {
    if (searchTerm === "") {
      setSearchValue("");
    }
  }, [searchTerm]);

  const handleSideBar = () => {
    setVerticleSidebar(!verticleSidebar);
  };

  // const handleSettingPage = () => {
  //   navigate(`/${userBaseIdMain}/job/${jobId}/manage/detail`)
  // }

  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("baseDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);

        if (parsedData && parsedData.data.base) {
          setBaseName(parsedData && parsedData.data.base);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, []);

  // Helper function to determine file type category
  const getFileTypeCategory = (
    file: File,
  ): "image" | "video" | "pdf" | "other" => {
    if (file.type.startsWith("image/")) return "image";
    if (file.type.startsWith("video/")) return "video";
    if (file.type === "application/pdf") return "pdf";
    return "other";
  };

  const handleSettingPage = () => {
    setOpen(true);
    // setShowSetting(true);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    // Take only the first file
    const file = files[0];

    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
      "video/mp4",
    ];

    const allowedExtensions = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".png",
      ".webp",
      ".mp4",
    ];
    const errors: string[] = [];

    // Check file size
    if (file.size > maxSizeInBytes) {
      errors.push(`${file.name} exceeds 10MB size limit`);
      setFileErrors(errors);
      return;
    }

    // Check file type by MIME type
    const isValidMimeType = allowedTypes.includes(file.type);

    // Check file extension as fallback
    const fileExtension = file.name
      .toLowerCase()
      .substring(file.name.lastIndexOf("."));
    const isValidExtension = allowedExtensions.includes(fileExtension);

    if (!isValidMimeType && !isValidExtension) {
      errors.push(
        `${file.name} is not a supported file type. Please upload PDF, JPG, PNG, WEBP, or MP4 files only.`,
      );
      setFileErrors(errors);
      return;
    }

    // Clear any previous errors
    setFileErrors([]);

    // Create file object with preview URL
    const fileId = `${file.name}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const fileType = getFileTypeCategory(file);
    let previewUrl: string | undefined;

    // Create preview URL for images and videos
    if (fileType === "image" || fileType === "video") {
      previewUrl = URL.createObjectURL(file);
    }

    // Set the single uploaded file
    setUploadedFile(file);
  };

  // Function to remove the file
  const removeFile = () => {
    if (uploadedFile?.previewUrl) {
      URL.revokeObjectURL(uploadedFile.previewUrl);
    }
    setUploadedFile(null);
  };

  // Updated File Preview Component
  const FilePreview = ({ fileObj, onRemove }: { onRemove: () => void }) => {
    return (
      <div className="flex items-center gap-2 bg-gray-100 p-1 px-2 rounded-md text-gray-700 w-fit">
        <span className="text-[12px] leading-4" title={fileObj?.name}>
          {fileObj?.name}
        </span>
        <button
          onClick={onRemove}
          className="flex-shrink-0 text-gray-700 rounded-full p-0.5 transition-colors"
          title="Remove file"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x cursor-pointer text-gray-500 hover:text-gray-500"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
    );
  };

  const handleSubmitMessage = async () => {
    if (!message.trim()) {
      toast.error("Please enter a message");
      return;
    }

    try {
      setIsLoading(true);

      const formData = new FormData();

      formData.append("message", message.trim());
      formData.append("type", selectedTab);

      if (uploadedFile) {
        formData.append("file", uploadedFile);
      }

      let fullUrl = `${COMMON.apiBaseUrl()}/v1/base/${baseId}/add.feedback`;

      const data = await _baseRequest(fullUrl, "POST", formData, {
        "Content-Type": "multipart/form-data",
      });

      toast.success(`Successfully sent feedback`);
      setMessage("");
      setFileErrors([]);
      setOpen(false);
      setShowSetting(false);
      setUploadedFile(null);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error.message || "An error occurred while sending feedback");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* header */}
      <div
        className={`${verticleSidebar ? "lg:pl-[0px]" : "lg:pl-[0px]"} transition-all duration-300`}
      >
        {!showSetting && (
          <div
            className="fixed top-0 sidebar-fixed sm:w-full"
            style={{ zIndex: 9 }}
          >
            <div className="flex w-full h-[53px] shrink-0 items-center gap-x-4 bg-zinc-100 px-4  sm:gap-x-6 sm:px-6 lg:px-4">
              <button
                type="button"
                onClick={() => setSidebarOpen(true)}
                className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
              >
                <span className="sr-only">Open sidebar</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#0000007a"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-search  w-[1.2rem] h-[1.2rem] text-[#0000007a]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                  <path d="M21 21l-6 -6" />
                </svg>
              </button>
              <div
                className="h-6 w-px bg-gray-900/10 lg:hidden"
                aria-hidden="true"
              />
              <div
                className="flex items-center relative"
                style={{
                  width: verticleSidebar
                    ? "calc(100% - 0px)"
                    : "calc(100% - 0px)",
                }}
              >
                <Link to={`/${baseId}/dashboard`}>
                  <div className="flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0.25rem]">
                    {updateBaseLogo === null ? (
                      <img
                        className="h-6 w-6 rounded-[5px]"
                        src={`${process.env.REACT_APP_API_BASE_URL}/uploads/base/logo/048b0d15-7a0a-4b5a-ad1a-9d973ce78c88.png`}
                      />
                    ) : (
                      <img
                        className="h-6 w-6 rounded-[5px]"
                        src={`${process.env.REACT_APP_API_BASE_URL}/${updateBaseLogo}`}
                        alt="base logo"
                      />
                    )}
                    {baseSwitchData?.name && (
                      <span
                        className="leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer truncate w-full max-w-[160px] min-w-[140px]
                       overflow-hidden text-ellipsis
                      text-start "
                      >
                        {baseSwitchData?.name}
                      </span>
                    )}

                    {/* <h2 className="text-black-100 font-semibold text-sm capitalize">
                      {jobId && jobStatus?.job_title}
                    </h2> */}
                  </div>
                </Link>

                <CommandKSearchJob />

                <div
                  className="flex items-center gap-x-2 ml-auto"
                  onClick={() => userNameRef.current?.click()}
                >
                  <div className="flex items-center gap-x-2 hover:bg-gray-200 cursor-pointer  px-2 py-[4px] rounded-md">
                    <CustomMenuDropdownVertical
                      imageUrl={imageUrl}
                      altText="User profile"
                      sections={profileMenuSections}
                      triggerRef={userNameRef} // Add this prop
                      menuItemsClassName="left-auto origin-top-right bottom-[auto] right-[-34px]"
                      nameFirstLetter={userData?.name ? userData?.name[0] : "A"}
                    />
                    <span
                      className="text-[13px] font-medium text-wedges-gray-900 capitalize"
                      onClick={() => userNameRef.current?.click()}
                    >
                      {userData?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* mobile sidebar */}
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 lg:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-900/80" />
          </Transition.Child>

          <div className="fixed inset-0 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute left-[82%] top-[-14px] flex w-16 justify-center pt-5">
                    <button
                      type="button"
                      className="-m-2.5 p-2.5"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                    </button>
                  </div>
                </Transition.Child>
                <div className="flex grow flex-col gap-y-4 overflow-y-auto bg-light-pink px-6 pb-4 py-4">
                  <div className="flex shrink-0 items-center px-[0rem] justify-between">
                    <Link to={`#`}>
                      <div className="flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0.25rem]">
                        <img
                          className="h-6 w-6 rounded-[5px]"
                          src={`https://pub-cc3cd436d40a477e89608a74e53ac0ec.r2.dev/uploads/logo/76592db3-5a50-4bec-9824-65c91ea060da.png`}
                          alt="base logo"
                        />
                        <span className="leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer capitalize">
                          M249
                        </span>
                      </div>
                    </Link>
                    <div className="flex items-center gap-x-4 lg:gap-x-6 w-[120px] relative z-50 [&>button]:hover:bg-transparent">
                      <img
                        className="h-6 w-6 rounded-full bg-gray-50"
                        src={`https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80`}
                        alt=""
                      />
                    </div>
                  </div>
                  <nav className="flex flex-1 flex-col">
                    <ul role="list" className="-mx-2 space-y-1">
                      {navigation.map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.to}
                            className={classNames(
                              item.current
                                ? " text-black-100 bg-[#00000014] hover:bg-[rgb(0 0 0 / 6%)] cursor-pointer"
                                : "text-black-100 hover:text-black-100 hover:bg-gray-100 cursor-pointer",
                              "group flex gap-x-[10px] p-0 text-[13px]  m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2",
                            )}
                          >
                            <item.icon
                              aria-hidden="true"
                              className={classNames(
                                item.current
                                  ? "text-[#808080]"
                                  : "text-red-100 group-hover:text-[#808080]",
                                "h-[1.1em] w-[1.1em] shrink-0",
                              )}
                            />
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      {!verticleSidebar && (
        <JobVerticleSidebar
          updateBaseLogo={updateBaseLogo}
          navigation={navigation}
          verticleSidebar={verticleSidebar}
          setVerticleSidebar={setVerticleSidebar}
        />
      )}

      {verticleSidebar && (
        <div
          className="hidden lg:fixed lg:inset-y-0 lg:z-[9] !top-[52px] lg:flex lg:w-[225px] lg:flex-col ml-2 mb-2 mt-[2px] rounded-tl-lg rounded-bl-lg ring-1 lg:ring-zinc-950/5 shadow-xs"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="flex grow flex-col bg-white pt-[0.75rem] rounded-tl-lg rounded-bl-lg px-0 pb-4 sidebar-des ">
            {/* <div className="flex shrink-0 items-center px-[0.75rem] justify-between">
              <Link to={`/${baseId}/dashboard`}>
                <div className='flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0.25rem]'>
                  {
                    updateBaseLogo === null ?

                      <img
                        className="h-6 w-6 rounded-[5px]"
                        src="https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250" /> :
                      <img
                        className="h-6 w-6 rounded-[5px]"
                        src={`${process.env.REACT_APP_API_BASE_URL}/${updateBaseLogo}`}
                        alt="base logo"
                      />
                  }

                  <span className='leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer truncate w-full max-w-[170px] min-w-[130px] overflow-hidden text-ellipsis
                 text-start capitalize '>{updateChannelName}</span>
                </div>
              </Link>

            </div> */}

            {/* <div className='mt-[1rem]'>  <CreateJob /></div> */}

            <nav className="flex flex-col px-[0.75rem]">
              <ul role="list" className="flex flex-1 flex-col gap-y-5">
                <li>
                  <ul role="list" className="">
                    {navigation.map((item) => {
                      const isActive = location.pathname.startsWith(item.to);

                      return (
                        <li
                          key={item.name}
                          className="h-[32px] first:mt-[0rem] mb-[2px] py-[2px] sidebar-nav"
                        >
                          <Link
                            to={item.to}
                            // to="#"
                            className={classNames(
                              isActive
                                ? "text-black-100 bg-gray-200 hover:bg-gray-300"
                                : "text-black-100 hover:text-black-100 hover:bg-gray-100",
                              "group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2",
                            )}
                          >
                            <item.icon
                              aria-hidden="true"
                              className={classNames(
                                isActive
                                  ? "text-[#0000007a]"
                                  : "text-[#0000007a] group-hover:text-black-100",
                                "h-[1.1em] w-[1.1em] shrink-0",
                              )}
                            />
                            {item.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              </ul>
            </nav>

            <li className="list-none px-[12px] pt-4 sidebar-nav mt-auto flex items-center justify-between">
              {/* {
                userData?.role === 'admin' &&
                <Link
                  to={`/${userBaseIdMain}/settings/base/`} // Adjust the path here to point to the correct settings route
                  className='group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2'
                >
                  <SettingIcon
                    className="h-[1.1em] w-[1.1em] shrink-0 text-[#0000007a] group-hover:text-black-100"
                    aria-hidden="true"
                  />
                  Settings
                </Link>
              } */}

              <button
                onClick={handleSettingPage}
                className="group flex gap-x-[10px] p-0 text-[13px] m-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-flag w-[1rem] h-[1rem] text-[#808080]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9z" />
                  <path d="M5 21v-7" />
                </svg>
                Share Feedback
              </button>
              {isHovered && (
                <button onClick={handleSideBar}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-layout-sidebar-right-expand w-[1rem] h-[1rem] text-[#808080]"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                    <path d="M15 4v16" />
                    <path d="M10 10l-2 2l2 2" />
                  </svg>
                </button>
              )}
            </li>
          </div>
        </div>
      )}

      <Transition show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 md:z-10 lg:z-10"
          onClose={() => setOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-6 py-6 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[680px]">
                  <div className="absolute right-0 top-0 hidden pr-6 pt-6 sm:block">
                    <button
                      type="button"
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => setOpen(false)}
                    >
                      <span className="sr-only">Close</span>
                      <X className="h-4 w-4" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left">
                      {/* <Dialog.Title as="h3" className="text-[15px] text-[#303031] font-medium leading-[1.4375rem]">
                        Contact us
                      </Dialog.Title> */}
                      <div className="mt-0">{renderTabContent()}</div>
                      <div className="mt-4">
                        <div className="flex space-x-2 flex-wrap md:flex-nowrap lg:flex-nowrap">
                          <button
                            type="button"
                            className={`
                                ${
                                  selectedTab === "problem"
                                    ? " bg-[#f7f7f7] rounded-[5px] px-2 py-[6px] flex items-center justify-center gap-x-2 text-[0.8125rem] text-[#303031] h-[36px]"
                                    : "bg-white  rounded-[5px] px-2 py-[6px] flex items-center justify-center gap-x-2 text-[0.8125rem] text-[#303031] h-[36px] "
                                }`}
                            onClick={() => setSelectedTab("problem")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-alert-square-rounded w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
                              <path d="M12 8v4" />
                              <path d="M12 16h.01" />
                            </svg>
                            Problem
                          </button>
                          <button
                            type="button"
                            className={`
                                ${
                                  selectedTab === "question"
                                    ? " bg-[#f7f7f7] rounded-[5px] px-2 py-[6px] flex items-center justify-center gap-x-2 text-[0.8125rem] text-[#303031] h-[36px]"
                                    : " bg-white rounded-[5px] px-2 py-[6px] flex items-center justify-center gap-x-2 text-[0.8125rem] text-[#303031] h-[36px] "
                                }`}
                            onClick={() => setSelectedTab("question")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-progress-help w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 16v.01" />
                              <path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
                              <path d="M10 20.777a8.942 8.942 0 0 1 -2.48 -.969" />
                              <path d="M14 3.223a9.003 9.003 0 0 1 0 17.554" />
                              <path d="M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592" />
                              <path d="M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305" />
                              <path d="M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356" />
                            </svg>
                            Question
                          </button>
                          <button
                            type="button"
                            className={`
                                ${
                                  selectedTab === "feedback"
                                    ? " bg-[#f7f7f7] rounded-[5px] px-2 py-[6px] flex items-center justify-center gap-x-2 text-[0.8125rem] text-[#303031] h-[36px]"
                                    : " bg-white rounded-[5px] px-2 py-[6px] flex items-center justify-center gap-x-2 text-[0.8125rem] text-[#303031] h-[36px] "
                                }`}
                            onClick={() => setSelectedTab("feedback")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-cash-move-back w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
                              <path d="M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5" />
                              <path d="M15.914 13.417a2 2 0 1 0 -2.447 2.511" />
                              <path d="M16 19h6" />
                              <path d="M19 16l-3 3l3 3" />
                            </svg>
                            Feedback
                          </button>
                        </div>
                        <textarea
                          className="mt-4 w-full border-[#e5e7eb] border-solid border rounded-md p-2 shadow-none text-[14px] text-[#303031]"
                          rows={7}
                          placeholder={getPlaceholderText()}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        ></textarea>

                        {/* File upload input */}
                        <div className="flex items-center space-x-2 text-gray-500">
                          <input
                            type="file"
                            id="file-upload"
                            className="hidden"
                            onChange={handleFileUpload}
                            accept=".pdf,.jpg,.jpeg,.png,.webp,.mp4"
                          />
                          <label
                            htmlFor="file-upload"
                            className="flex items-center cursor-pointer gap-x-2 !ml-0"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="#5e5e5f"
                              role="img"
                              focusable="false"
                              aria-hidden="true"
                            >
                              <path d="M12.6429 7.69048L8.92925 11.4041C7.48164 12.8517 5.34347 13.0101 4.16667 11.8333C2.98733 10.654 3.14447 8.52219 4.59216 7.07451L8.00206 3.66461C8.93557 2.73109 10.2976 2.63095 11.0333 3.36667C11.7681 4.10139 11.6658 5.4675 10.7361 6.39727L7.32363 9.8097C6.90202 10.2313 6.32171 10.2741 6.02381 9.97619C5.72651 9.6789 5.76949 9.09718 6.1989 8.66776L9.29048 5.57619C9.56662 5.30005 9.56662 4.85233 9.29048 4.57619C9.01433 4.30005 8.56662 4.30005 8.29048 4.57619L5.1989 7.66776C4.24737 8.6193 4.13865 10.091 5.02381 10.9762C5.9095 11.8619 7.37984 11.7535 8.32363 10.8097L11.7361 7.39727C13.1876 5.94573 13.3564 3.68975 12.0333 2.36667C10.7099 1.04326 8.45782 1.20884 7.00206 2.66461L3.59216 6.07451C1.62229 8.04437 1.39955 11.0662 3.16667 12.8333C4.93146 14.5981 7.9596 14.3737 9.92925 12.4041L13.6429 8.69048C13.919 8.41433 13.919 7.96662 13.6429 7.69048C13.3667 7.41433 12.919 7.41433 12.6429 7.69048Z"></path>
                            </svg>
                            <span className="text-[#5e5e5f] text-[13px]">
                              Attach images, files or videos.
                            </span>
                          </label>
                        </div>

                        {fileErrors.length > 0 && (
                          <div className="mt-2 p-[6px] bg-red-50 border border-red-200 rounded">
                            {fileErrors.map((error, index) => (
                              <p
                                key={index}
                                className="text-[12px] text-red-600 leading-4"
                              >
                                {error}
                              </p>
                            ))}
                          </div>
                        )}

                        {/* File previews - Tag style */}
                        {uploadedFile && (
                          <div className="mt-2">
                            <FilePreview
                              fileObj={uploadedFile}
                              onRemove={removeFile}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <span className="border-b border-solid border-[#e3e3e3] mx-[-32px] block py-[6px]"></span>
                  <div className="flex items-center justify-between gap-[22px] pt-4 flex-wrap md:flex-nowrap lg:flex-nowrap">
                    <span className="text-[#5e5e5f] text-[0.75rem] leading-normal font-normal">
                      You can also email us
                      <a href="mailto:support@teamer.app">
                        {" "}
                        support@teamer.app
                      </a>
                    </span>

                    <button
                      type="button"
                      onClick={handleSubmitMessage}
                      className="group w-fit inline-flex shrink-0 select-none items-center justify-end px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                      // onClick={() => setOpen(false)}
                    >
                      {isLoading ? (
                        <div className="flex items-center gap-[6px]">
                          Send message
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        " Send message"
                      )}
                    </button>
                    {/* <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </button> */}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default Sidebar;
